import { useErrorHandlingSlice } from 'app/error/slice';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useApi from 'services/mavapi/useApi';
import {
  Module,
  PermissionApIsService,
  RolePermission,
} from 'services/openapi';

export const usePermissionsApi = () => {
  const { actions } = useErrorHandlingSlice();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [, setError] = useState<unknown | null>();
  const { error: apiError, handleRequest } = useApi();
  const {
    permissionGetRoleBasedPermissions,
    permissionCreateRolePermissions,
    permissionGetPermission,
  } = PermissionApIsService;
  const [rolePermissionsList, setRolePermissionsList] =
    useState<Array<Module> | null>(null);
  const [permissionPayloadDefault, setPermissionPayloadDefault] =
    useState<Array<Module> | null>(null);
  const [roleName, setRoleName] = useState<string>('');
  const [roleNameDefault, setRoleNameDefault] = useState<string>('');

  const getRolePermissionsList = (
    roleId?: string,
    isUserUpdate?: boolean,
    userId?: string,
  ) => {
    setLoading(true);
    handleRequest(permissionGetRoleBasedPermissions(roleId))
      .then(res => {
        if (res) {
          if (isUserUpdate) {
            getUserPermissionsList(userId);
          } else {
            setRolePermissionsList(res?.modules);
            setPermissionPayloadDefault(res?.modules)
          }
          setRoleName(res?.roleName);
          setRoleNameDefault(res?.roleName);
        }
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  };
  const getUserPermissionsList = (userId?: string) => {
    setLoading(true);
    handleRequest(permissionGetPermission(userId))
      .then(res => {
        if (res) {
          setRolePermissionsList(res?.modules);
        }
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  };

  const handleCreateRolePermissions = (requestBody?: RolePermission) => {
    setSaveLoading(true);
    handleRequest(permissionCreateRolePermissions(requestBody))
      .then(res => {
        if (res) {
          if (res.code === 'RoleNameAlreadyExist') {
            dispatch(
              actions.dispatchToast({
                errorTxt: 'Role Already Exist',
                show: true,
                errorType: 'error',
              }),
            );
            setSaveLoading(false);
          } else {
            getRolePermissionsList();
            setSaveLoading(false);
            navigate(`/admin/settings/roles`);
            if (requestBody?.roleId) {
              dispatch(
                actions.dispatchToast({
                  errorTxt: 'Role Updated Successfully',
                  show: true,
                  errorType: 'success',
                }),
              );
            } else {
              dispatch(
                actions.dispatchToast({
                  errorTxt: 'Role Created Successfully',
                  show: true,
                  errorType: 'success',
                }),
              );
            }
          }
        }
      })
      .catch(() => {
        setError(apiError);
        setSaveLoading(false);
      });
  };

  return {
    loading,
    getRolePermissionsList,
    rolePermissionsList,
    setRolePermissionsList,
    handleCreateRolePermissions,
    roleName,
    saveLoading,
    getUserPermissionsList,
    setRoleName,
    permissionPayloadDefault,
    roleNameDefault
  };
};
